export default [
    {
        path: 'notifications',
        component: ()=>import('@/feature/customer/notifications/presentation/views/notifications'),
        meta: {
            breadcrumb: [
                {label: 'Inicio', link: '/'},
                {label: 'Notificaciones'}
            ]
        }
    },
]